import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-t-circle', 'LetterTCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 8.25h3m0 0h3m-3 0v8","key":"svg-0"}]]);